import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, watch } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'commonGroupMultiSelect',
  props: {
    fieldlabel: { type: String, default: "" },
    modelValue: [Number, String, Boolean, Array],
    name: { type: String, required: true },
    parent: { type: String, default: "", },
    propname: { type: String, required: false },
    placeholder: { type: String, default: "" },
    v$: Object,
    options: Object,
    optionLabel: { type: String, default: "Text" },
    optionGroupLabel: { type: String, default: "Text" },
    optionGroupChildren: { type: String, default: "items" },
    optionValue: { type: [Number, String], default: "Value" },
    filter: { type: Boolean, default: false },
    mode: String,
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    callBack: Function,
    datatype: String,
    showToggleAll: { type: Boolean, default: false },
    maxSelectedLabels: { type: Number, default: 1 },
    selectedItemsLabel: { type: String, default: "" },
    IsShowCount: { type: Boolean, default: false },
    callCountBack: Function,
},
  emits: ["update:modelValue", "update:title"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;
const IsValue = ref(false);
const Props = __props;
const Isloading = ref(false);
const updateValue = (value: any) => {
    IsValue.value = true;
    if (Props.modelValue != value) {
        emit("update:modelValue", value);
        try {
            if ((value || []).length > 0) {
                const records = [] as any
                (Props.options || [])?.forEach((els: any) => {
                    let arr = (els.items || []).filter(i => value.includes(i.Value))
                    if ((arr || []).length > 0) {
                        (arr || [])?.forEach((fels: any) => {
                            records.push(fels)
                        })
                    }
                })
                const CSVOf_arr = records.map((item: any) => { return item.Text }).join(', ')
                emit("update:title", CSVOf_arr);
            }
            else {
                emit("update:title", "");
            }

        } catch (err) {
            //nothing to do
        }
        if (typeof Props.callBack != "undefined") {
            Props.callBack(value);
        }
    }
};
watch(() => Props.options, () => {
    SetData(Props.options);
});
const ListOption = ref(Props.options);
const SetData = (list: any) => {
    if (list) {
        ListOption.value = list;
        updateValue(Props.modelValue);
    }
}
const SetValues = (value: any) => {
    updateValue(value);
}
const ShowCountClick = (value: any, Count?: any) => {
    if (Count > 0) {
        if (typeof Props.callCountBack != "undefined") {
            Props.callCountBack(value);
        }
    }
}
__expose({ SetData, SetValues });

const __returned__ = { emit, IsValue, Props, Isloading, updateValue, ListOption, SetData, SetValues, ShowCountClick }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})